const exhibitionCards = document.querySelectorAll('.two-col-card-list .card');

if (exhibitionCards.length > 0) {
  const rowSize = 2;

  const total = exhibitionCards.length;
  const lastRowCount = total % rowSize || rowSize;

  [...exhibitionCards].slice(-lastRowCount).forEach((card) => card.classList.add('no-border'));
}
